import { Injectable, EventEmitter } from '@angular/core';
import Subscriber from 'src/app/models/subscriber';
import Plan from '../models/plan';
import WizardRefreshRequest from '../models/wizardRefreshRequest';
import EnrollmentPeriod from '../models/enrollmentPeriod';

@Injectable({
  providedIn: 'root'
})
export class WizardRefreshService {
    private _refreshRequestEvent = new EventEmitter<WizardRefreshRequest>();
    private _nextPageEvent = new EventEmitter<EnrollmentPeriod>();
    private _previousPageEvent = new EventEmitter<EnrollmentPeriod>();
    private _milestonesUpdatedEvent = new EventEmitter<any[]>();
    private _formattedMilestones: any[];

    get formattedMilestones(): any[] {
        return this._formattedMilestones;
    }

    set formattedMilestones(milestones: any[]) {
        this._formattedMilestones = milestones;
        this._milestonesUpdatedEvent.emit(this._formattedMilestones);
    }

    get refreshRequest(): EventEmitter<WizardRefreshRequest> {
        return this._refreshRequestEvent;
    }

    get nextPage(): EventEmitter<EnrollmentPeriod> {
        return this._nextPageEvent;
    }

    get previousPage(): EventEmitter<EnrollmentPeriod> {
        return this._previousPageEvent;
    }

    emitRefreshRequest(subscriber: Subscriber, planSelections: { [k: string]: Plan }) {
        const data: WizardRefreshRequest = {
            subscriber,
            planSelections
        };

        this._refreshRequestEvent.emit(data);
    }

    emitNextPageRequest(enrollmentPeriod: EnrollmentPeriod): void {
        this._nextPageEvent.emit(enrollmentPeriod);
    }

    emitPreviousPageRequest(enrollmentPeriod: EnrollmentPeriod): void {
        this._previousPageEvent.emit(enrollmentPeriod);
    }

    get milestonesUpdated() {
        return this._milestonesUpdatedEvent;
    }
}